import React, { Component } from 'react'
import Slide from './Slide'
import Buttons from './Buttons'
import { extendParentClass } from '../../../utils/classes'
import { ReactComponent as Team } from './images/team.svg'
import { ReactComponent as Video } from './images/video.svg'
import { ReactComponent as Search } from './images/search.svg'
import { ReactComponent as Task } from './images/task.svg'
import { ReactComponent as Apps } from './images/apps.svg'

export class Slides extends Component {
  baseClass = extendParentClass.bind(this)('slides')

  state = {
    slide: 0,
  }

  slides = [
    {
      title: 'Bring your team together',
      description:
        'Get access to everyone in your organization with customizable channels and a team directory.',
      Image: Team,
    },
    {
      title: 'Make video calls with one click',
      description: `Stay connected with mosto's powerful inbuilt video conference feature. You can even screen share with just a click.`,
      Image: Video,
    },
    {
      title: 'Easily find and share information',
      description: `Powerful search helps you find anything shared in Mosto, whether it’s a message, file, or link.`,
      Image: Search,
    },
    {
      title: 'Stay on track with apps',
      description:
        'Use our powerful suite of business collaboration tools - Shared To-Dos, Polls, Note Sharing, Reminders, and more - to optimize project management.',
      Image: Task,
    },
    {
      title: 'Integrate your favorite tools',
      description:
        'Mosto offers over 50 integrations with tools like Asana, Twitter, Googe Drive, and Todoist. Add your apps in mosto with one click and you’ll never need to switch tools to get work done.',
      Image: Apps,
    },
  ]

  renderSlide = () => {
    const { slide } = this.state
    const slideData = this.slides[slide]
    return <Slide {...slideData} parentClass={this.baseClass} />
  }

  setSlide = (slide) => this.setState({ slide })

  render() {
    const { slide } = this.state
    return (
      <div className={this.baseClass}>
        <Buttons
          parentClass={this.baseClass}
          slide={slide}
          setSlide={this.setSlide}
        />
        {this.renderSlide()}
      </div>
    )
  }
}

export default Slides
